export function PARAM_CHANGE(store, name, newVal) {
  store.set(name, newVal);
}
